import React from 'react';
import { PageContextType } from 'types';
import { Heading } from '../../LANDR/Heading';
import { Grid, GridCol, GridRow } from '../../UI/Grid';
import { Container } from '../../UI/Container/Container';
import { SliceContext } from '../types';
import { PricingTable, PricingTableDocument } from './PricingTable/PricingTable';
import './Pricing.scss';

export type PricingSliceProps = {
    pageContext: PageContextType;
    sliceContext: SliceContext;
    slice: {
        slice_type: 'pricing';
        primary: {
            pricing_table: {
                document: PricingTableDocument[];
            };
            pricing_title: string;
        };
    };
};

class Pricing extends React.Component<PricingSliceProps> {
    constructor(props: PricingSliceProps) {
        super(props);
    }

    render() {
        const { pricing_table, pricing_title } = this.props.slice.primary;
        return (
            <Container size="md" className="Pricing">
                {pricing_title && (
                    <Grid>
                        <GridRow>
                            <GridCol colSize={'12'}>
                                <Heading className="Pricing-header" size="mg">
                                    {pricing_title}
                                </Heading>
                            </GridCol>
                        </GridRow>
                    </Grid>
                )}
                <PricingTable
                    table={pricing_table.document[0]}
                    sliceContext={this.props.sliceContext}
                    pageContext={this.props.pageContext}
                />
            </Container>
        );
    }
}

export { Pricing };
